<script lang="ts">
    import { onMount } from 'svelte'
    import type { Purchase } from '../../../modules/paymentsApi/purchases/purchase.entity'
    import { GridBadge, GridButton, GridClass, GridCol, GridColTypeEnum, GridLine } from '../../_common/z/zgrid'
    import { faBarcode, faSearchDollar, faFileInvoiceDollar } from '@fortawesome/free-solid-svg-icons'
    import type { Charge } from '../../../modules/paymentsApi/charges/charge.entity'
    import { ChargeStatus, ChargeStatusFriendly } from '../../../modules/paymentsApi/charges/charge.enum'
    import Content from '../../_common/content.svelte'
    import Zgrid from '../../_common/z/zgrid.svelte'
    import Zframe from '../../_common/z/zframe.svelte'
    import Popover from '../../_common/popover.svelte'
    import Zinput from '../../_common/z/zinput.svelte'
    import SubscriptionList from './subscription-list.svelte'

    let purchase: Purchase
    let overdue = false

    let showPlanAlert =
        window.store.company.planForceChargeAlert ||
        window.store.company.planStatus === 'blocked' ||
        window.store.company.planStatus === 'blocked_trial' ||
        window.store.company.planStatus === 'renew' ||
        window.store.company.planStatus === 'overdue'

    onMount(async () => {})

    function showOverdue() {
        overdue = true
    }
</script>

<Content footer={true}>
    <SubscriptionList on:overdue={showOverdue}></SubscriptionList>
    {#if overdue || showPlanAlert}
        <Zframe class="mt-3" title="Não foi possível receber seu último pagamento.">
            <p>Isso pode ocorrer por vários motivos:</p>
            <ul>
                <li>Seu banco negou o pagamento via cartão de crédito por um bloqueio de segurança;</li>
                <li>Seu cartão de crédito está bloqueado ou vencido;</li>
                <li>Seu cartão de crédito está sem limite.</li>
                <li>Sua assinatura é por boleto e o mesmo ainda não foi pago;</li>
            </ul>
            <p>
                Em caso de bloqueio de segurança:<br />
                <span class="text-muted">
                    Entre em contato com seu banco e informe o valor da parcela que foi negada e a data. Informe que tentou fazer o pagamento mas foi negado e
                    que você gostaria de autorizar este pagamento.<br />
                    Após o banco informar que foi feita a liberação basta aguardar que tentaremos cobrar novamente em seu cartão.
                </span>
            </p>
            <p>
                Em caso de cartão vencido ou bloqueado:<br />
                <span class="text-muted"> Entre em contato com o suporte e solicite um link para atualizar os dados de seu cartão. </span>
            </p>
            <p>
                Em caso de falta de limite:<br />
                <span class="text-muted">
                    Tentaremos cobrar novamente outra vez em seu cartão muito em breve. Caso haja limite a cobrança será feita automaticamente.
                </span>
            </p>
            <p>
                Em caso de boleto em aberto:<br />
                <span class="text-muted"> Realize o pagamento do boleto. Mesmo atrasado um boleto poderá ser pago normalmente. </span>
            </p>
            <p>
                Dúvidas?<br />
                Entre em contato com o financeiro: financeiro@zandu.com.br
            </p>
            <div class="alert alert-warning">
                Importante: em caso de bloqueio por falha no pagamento o desbloqueio não poderá ser feito pelo suporte.<br />
                Neste caso entre em contato com o financeiro pelo e-mail financeiro@zandu.com.br
            </div>
        </Zframe>
    {/if}
</Content>
